define('OutSystems/ReactWidgets/AdvancedHtml',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AdvancedHtml = void 0;
    var AdvancedHtml = (function (_super) {
        tslib_1.__extends(AdvancedHtml, _super);
        function AdvancedHtml() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AdvancedHtml.prototype.render = function () {
            var tagFactory = React.createElement.bind(null, this.props.tag);
            if (tagFactory) {
                var attributes = {
                    "data-advancedhtml": "",
                };
                this.fillWithBuiltinProperties(attributes);
                return tagFactory(attributes, this.props.children);
            }
            return null;
        };
        AdvancedHtml = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], AdvancedHtml);
        return AdvancedHtml;
    }(Widget_1.Widget));
    exports.AdvancedHtml = AdvancedHtml;
});
//# sourceMappingURL=AdvancedHtml.js.map;
